import React from 'react';
import questionProjections from '../../projections/question';
import PropTypes from 'prop-types';
import { useAppSelector } from '../../hooks/hooks';
import { useTranslation } from 'react-i18next';
import tickIcon from '../../assets/images/tick.png';

type Props = { questionCode: string | null; asnwerValues: Array<any> };
type Item = {
    id: React.Key | null | undefined;
    name:
        | string
        | number
        | boolean
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | React.ReactFragment
        | React.ReactPortal
        | null
        | undefined;
};

const QuestionDocumentTypes = (props: Props): JSX.Element => {
    const { questionCode, asnwerValues } = props;
    const questionDocumentTypes = useAppSelector(
        questionProjections.attachmentsQuestionDocumentTypes(
            questionCode,
            asnwerValues,
        ),
    );
    const { t } = useTranslation();
    return (
        <div className={'form-group'}>
            <div className={'col-sm-12'}>
                {t('attachmentsSpecified') as string}
                <ul
                    style={{
                        marginBlockStart: '1em',
                        marginBlockEnd: '1em',
                        marginInlineStart: '0px',
                        marginInlineEnd: '0px',
                        paddingInlineStart: '40px',
                    }}
                >
                    {questionDocumentTypes.map((item: Item) => (
                        <li key={item.id}>
                            <img
                                src={tickIcon}
                                alt="questionDocType"
                                style={{ marginRight: '8px', width: '15px' }}
                            />
                            <strong>{item.name}</strong>
                        </li>
                    ))}
                </ul>
                {t('attachmentType') as string}
            </div>
        </div>
    );
};

QuestionDocumentTypes.propTypes = {
    questionCode: PropTypes.string.isRequired,
};

export default QuestionDocumentTypes;
